const countFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/** A whole-number count with en-US thousands separators ("34802" -> "34,802"). */
export const formatCount = (value: number | string): string => {
  const count = Number(value);
  return Number.isFinite(count) ? countFormatter.format(count) : String(value);
};
